import React from 'react';
import {MainLayout} from 'components/layouts';
import {HighlightBusinessForm} from 'components/highlight-businesses';
import {HighlightBusinesses} from 'base/api';
import {toastr} from 'react-redux-toastr';

class AddHighlightBusinessPage extends React.Component {
  constructor(props, context) {
    super(props, context);

  }
  cb(response) {
    // Back to home banners list
    toastr.success('Thành công!', 'Doanh nghiệp nổi bật đã được thêm thành công.');

    this.props.history.push('/highlight-businesses');
  }

  render() {
    return (
      <MainLayout>
        <div>
          <div className="register-logo">
            <b>Thêm mới banner</b>
          </div>
          <HighlightBusinessForm fnSubmit={HighlightBusinesses.actions.add} cb={this.cb.bind(this)}/>
        </div>
      </MainLayout>
    );
  }
}

AddHighlightBusinessPage.contextTypes = {
  router: React.PropTypes.object
};

export default AddHighlightBusinessPage;



// WEBPACK FOOTER //
// ./pages/highlight-businesses/AddHighlightBusinessPage.jsx